import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { TestSubsection } from "./TestSection";
import { Palette, FileText, Star, QrCode, TrendingUp as LeadsIcon, Users, Ticket, GitCompare } from "lucide-react";
import * as tests from "./testDefinitions";

export const CustomersSection = ({ testResults }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">Customers</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <TestSubsection
          icon={Palette}
          iconColor="text-pink-600"
          title="Branding"
          tests={tests.brandingTests}
          results={testResults.branding}
        />
        
        <TestSubsection
          icon={FileText}
          iconColor="text-red-600"
          title="Waivers"
          tests={tests.waiversTests}
          results={testResults.waivers}
        />
        
        <TestSubsection
          icon={Star}
          iconColor="text-yellow-600"
          title="Reviews"
          tests={tests.reviewsTests}
          results={testResults.reviews}
        />
        
        <TestSubsection
          icon={QrCode}
          iconColor="text-purple-600"
          title="Check-In"
          tests={tests.checkinTests}
          results={testResults.checkin}
        />
        
        <TestSubsection
          icon={LeadsIcon}
          iconColor="text-blue-600"
          title="Leads"
          tests={tests.leadsTests}
          results={testResults.leads}
        />
        
        <TestSubsection
          icon={GitCompare}
          iconColor="text-amber-600"
          title="Leads Consistency (Dashboard ↔ Relations)"
          tests={tests.leadsConsistencyTests}
          results={testResults['leads-consistency']}
        />
        
        <TestSubsection
          icon={Users}
          iconColor="text-green-600"
          title="Relations"
          tests={tests.relationsTests}
          results={testResults.relations}
        />
        
        <TestSubsection
          icon={Ticket}
          iconColor="text-orange-600"
          title="Tickets"
          tests={tests.ticketsTests}
          results={testResults.tickets}
        />
      </CardContent>
    </Card>
  );
};
